<div class="wz-grid">
  <div class="wz-main">
    <app-schedule-form></app-schedule-form>
  </div>

  <aside class="wz-aside" aria-label="Send times">
    <app-schedule-preview (openPopupEvent)="openPopup($event)"></app-schedule-preview>
  </aside>
</div>

@if (openEditPopup) {
  <app-edit-schedule-form (closePopupEvent)="closePopup($event)" [open]="openEditPopup"></app-edit-schedule-form>
}
